import { marked } from 'marked';
import { POST_REQUEST } from './network';

class MarkdownService {

    constructor() {
        marked.use({
            breaks: true,
            sanitize: false,
            gfm: true
        });
    }

    appendTo = (obj) => {
        if (typeof obj === "object" && obj !== null) {
            obj.markdown = this.markdown,
                obj.markdownStream = this.markdownStream,
                obj.fetchStream = this.fetchStream;
        }
    }

    /**
     * Translate markdown text into html
     */
    markdown = text => {
        //todo: understand why could not be achieved with custom parser
        let tabuid = "2cb3acff108d4896ae95ba2077b74652";
        let coduid = "33dde4ebec8b437eaa1d80525f07292e";
        let docuid = "b968de5ba385432fb0e9bcd7a289f467";
        let spauid = "9351ddfe6caa44be8e725e2907232755";
        let manipulate = text.includes("\t") || text.includes("```sql");
        if (manipulate) {
            text = text.replaceAll("\t", tabuid)
                .replaceAll("```sql", coduid)
                .replaceAll("```", docuid)
                .replaceAll("\n   ", spauid);
        }
        text = marked.parse(text);
        if (manipulate) {
            text = text.replaceAll(tabuid, "&nbsp;&nbsp;&nbsp;&nbsp;")
                .replaceAll(coduid, "<code>")
                .replaceAll(docuid, "</code>")
                .replaceAll(spauid, "\n&nbsp;&nbsp;&nbsp;");
        }
        return text;
    }

    scroll = scrollContainer => {
        if (scrollContainer) {
            scrollContainer.scrollTop = scrollContainer.scrollHeight - scrollContainer.clientHeight;
        }
    }

    /**
     * Stream markdown from text chunks to html
     * 
     * @param {*} contentElement  The element that will receive the markdown elements 
     * @param {*} scrollContainer An optional scroll container for scroll into view behaviour
     * @param {*} rednerComplete An optional callback to be called when render is complete. This is called when the animation is complete (can be a while after last chunk)
     * @returns A function used to stream additional chunks. Call it with the text of each chunk. Call it with no input to signal end of stream
     */
    markdownStream = (contentElement, scrollContainer, rednerComplete = () => {}) => {
        let chunks = "";
        let content = "";
        let at = 0;
        let done = false;
        const pulse = '<span class="pulse"><span>';
        const self = this;
        contentElement.innerHTML = pulse;
        this.scroll(scrollContainer);

        const nextValidChar = (s, from) => {
            var i = from;
            while (i < s.length && i != -1) {
                var c = s[i];
                // for now we assume that we always have the closing.
                if (c == '<') {
                    i = s.indexOf('>', i) + 1;
                } else if (s[i] == '&') {
                    i = s.indexOf(';', i) + 1;
                } else if (c == '\n' || c == ' ' || c == '\r') {
                    ++i;
                } else {
                    return i;
                }
            }
            return -1;
        };

        const more = () => {
            const isScrolledToBottom = scrollContainer && scrollContainer.scrollHeight - scrollContainer.clientHeight <= scrollContainer.scrollTop + 1;
            let writeTo = nextValidChar(content, at);
            if (writeTo != -1) {
                contentElement.innerHTML = content.substring(0, writeTo) + pulse;
                at = writeTo + 1;
                if (isScrolledToBottom) {
                    self.scroll(scrollContainer);
                }
            } else if (done) {
                contentElement.innerHTML = content;
                if (isScrolledToBottom) {
                    self.scroll(scrollContainer);
                }
                rednerComplete();
                clearInterval(intervalId);
            }
        };

        let intervalId = setInterval(more, 5);

        const addChunk = (chunk) => {
            if (chunk != null) {
                chunks += chunk;
                content = this.markdown(chunks);
            } else {
                done = true;
            }
        };
        return addChunk;
    }


    /**
     * @param {*} endpointName The fabric endpoint to call 
     * @param {*} params Parameters to pass
     * @param {*} callback Callback function to call as chunks of text arrive. Calling with no params signals stream is done.
     * @param {string} verb optional, default value is POST
     * @param {string} version optional, fabric api version, default value latest version
     * @param {string} servlet optional, servlet name, default is 'api' can be 'broadway'
     * @returns void
     */
    fetchStream = async (endpointName, params = {}, callback, verb = POST_REQUEST, version, servlet) => {
        try {
            const k2api = window.k2api || window.top.k2api;
            params.stream = true;
            const response = await k2api.invokeFabricWebService(endpointName, params, verb, version, true, servlet);
            if (response.isError) {
                throw new Error(response.name);
            }
            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            let { done, value } = await reader.read();
            while (!done) {
                let chunk = decoder.decode(value, { stream: true });
                ({ done, value } = await reader.read());
                callback(chunk);
            }
            callback();
        } catch (error) {
            callback(error);
            callback();
        }
    }
}

export const markdownService = new MarkdownService();